// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DidYouMeanPlugin {
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'DidYouMe... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   invoke(data: any, feed: any) {
      const dym = data.search.recommendations.did_you_mean
      let item = null
      if (dym && dym.length) {
         if (dym[0].suggestion?.original_query != null) {
            item = {
               dym: dym[0].suggestion,
               type: 'didYouMeanSuggestion'
            }
         } else if (dym[0].correction?.original_query != null) {
            item = {
               dym: dym[0].correction,
               type: 'didYouMeanCorrection'
            }
         } else if (dym[0].expansion?.original_query != null) {
            item = {
               dym: dym[0].expansion,
               type: 'didYouMeanExpansion'
            }
         }
         return feed.addPositionalItem(item, 1)
      }
   }
}
DidYouMeanPlugin.initClass()

angular.module('summonApp.resultsFeedPlugins')
   .service('didYouMeanPlugin', DidYouMeanPlugin)
